module.service('ReportService', function($http, ApiUrl, momentConvertFilter) {
    var url = ApiUrl.partial('reports');

    this.getFieldIndexReport = function(reports) {
        return new FieldIndexReport(url('field_details'), reports);
    };

    this.getProgramIndexReport = function(program, reports) {
        return new FieldIndexReport(url('field_details', program.id), reports)
    }

    this.getFieldDetailReport = function(name) {
        var report_url = url('field_details', name);
        return new FieldDetailReport(report_url);
    };

    this.getProgramDetailReport = function(name, program) {
        var report_url = url('field_details', name, program.id);
        return new ProgramDetailReport(report_url);
    };


    function FieldIndexReport(url, reports) {
        var report = this;
        this.loading = false;
        this.year = null;

        for (var i = 0; i < reports.length; i++) {
            this[reports[i]] = {};
        }

        this.update = function(params) {
            if (!params) return;

            params = angular.copy(params);
            params.reports = reports;

            if (angular.isArray(params.year) && params.year.length === 1) {
                report.year = parseInt(params.year[0]);
            } else {
                report.year = null;
            }

            return $http.get(url, {params: params}).then(function(response) {
                updateData(response.data.item);
                report.loading = false;
                return report;
            });
        };

        function updateData(data) {
            var name, i;
            for (i = 0; i < reports.length; i++) {
                name = reports[i];
                angular.copy(data[name], report[name]);
            }
        }
    }

    function FieldDetailReport(url) {
        var dataFields = ['programs', 'pager', 'field'];
        this.programs = [];
        this.pager = {};
        this.field = {};
        this.loading = false;
        this.update = updateDetailReport.bind(this, url, dataFields);
    }

    function ProgramDetailReport(url) {
        var dataFields = ['students', 'pager', 'program'];
        this.students = [];
        this.pager = {};
        this.program = {};
        this.loading = false;
        this.update = updateDetailReport.bind(this, url, dataFields);
    }

    function updateDetailReport(url, dataFields, params) {
        this.loading = true;
        return $http.get(url, {params: params})
            .then(copyDetailReportFields(this, dataFields));

    }

    function copyDetailReportFields(report, dataFields) {
        return function(response) {
            var i, name, data = response.data.item;
            data = momentConvertFilter(data);
            report.loading = false;
            for (i = 0; i < dataFields.length; i++) {
                name = dataFields[i];
                angular.copy(data[name], report[name]);
            }
        };
    }

});

module.service('Sorter', function($location) {

    function Sorter(report, config) {
        var search = $location.search();

        this.report = report;
        this.config = config || {};
        this.config.default = this.config.default || 'name';
        this.config.direction = this.config.direction || 'asc';

        this._direction = search.direction || this.config.direction;

        if (!search.sort || this.config.columns.indexOf(search.sort) !== -1) {
            this._column = search.sort || this.config.default;
        } else {
            this._column = this.config.default;
            this._direction = this.config.direction;
            $location.search('direction', null);
            $location.search('sort', null);
            $location.replace();
        }
}

    Sorter.prototype.toJSON = function() {
        return {column: this._column, direction: this._direction,
                asc: this.asc, desc: this.desc};
    };

    Object.defineProperty(Sorter.prototype, 'column',  {
        get: function() { return this._column; },
        set: function(value) {
            if (this._column !== value) {
                if (this.config.columns.indexOf(value) === -1) {
                    value = this.config.default;
                }
                this._column = value;
                if (this.report.pager) {this.report.pager.page = 1;}
                this.report.refresh()
                setSearch('sort', value, this.config.default);
            }
        },
    });

    function setSearch(name, value, defaultValue) {
        value = value === defaultValue ? undefined : value;
        $location.search(name, value);
        $location.replace();
    }

    Object.defineProperty(Sorter.prototype, 'direction', {
        get: function() {return this._direction; },
        set: function(value) {
            value = value === 'desc' ? 'desc' : 'asc';
            if (value !== this._direction) {
                this._direction = value;
                if (this.report.pager) {this.report.pager.page = 1;}
                this.report.refresh();
                setSearch('direction', value, this.config.direction);
            }
        }
    });

    Object.defineProperty(Sorter.prototype, 'asc', {
        get: function() {return this._direction === 'asc'; },
        set: function(value) {
            this.direction = !!value ? 'asc' : 'desc';
        },
    });

    Object.defineProperty(Sorter.prototype, 'desc', {
        get: function() {return this._direction === 'desc'; },
        set: function(value) {
            this.direction = !!value ? 'desc' : 'asc';
        },
    });

    return Sorter;
});


module.service('Pager', function($location) {
    function Pager(report) {
        this.report = report;
        this._page = parseInt($location.search().page || 1);
    }

    Pager.prototype.setData = function(pager) {
        this._page = pager.page || 1;
        this.pages = pager.pages;
        this.total = pager.total;
    };

    Pager.prototype.toJSON = function() {
        return {page: this.page, pages: this.pages, total: this.total};
    }

    Object.defineProperty(Pager.prototype, 'page', {
        get: function() {return this._page},
        set: function(value) {

            var oldPage = this._page;
            var newPage = value;
            if (angular.isDefined(this.pages)) {
                newPage = Math.max(1, Math.min(this.pages, value));
            }

            if (isNaN(newPage)) return;

            if (oldPage !== newPage) {
                this.report.refresh();
                this._page = newPage;
            }
            $location.search('page', this._page === 1 ? undefined : this.page);
            $location.replace();
        }
    });

    return Pager;
});


module.service('Report', function($q, $http, $state, $timeout, ApiUrl, Pager,
                                  Sorter, momentConvertFilter) {

    function Report(url) {
        this.url = ApiUrl.apply(ApiUrl, url);
        this.loaded = false;
        this.loading = false;

        this.$timeoutCancel = undefined;

        if (this.$isList) {
            this.data = [];
            this.pager = new Pager(this);
        } else {
            this.data = {};
        }

        if (this.$isList) {
            this.sorter = new Sorter(this, this.$sorterConfig || {});
        }
    }

    function setLoaded(report) {
        return function() {
            report.loading = false;
            report.loaded = true;
        }
    }

    Report.addPercentColumns = function(cls, def) {
        for (var name in def) {
            Object.defineProperty(cls.prototype, name, {
                get: makePercentGetter.apply(this, def[name]),
            });
        }
    }

    Report.makeGetter = function(cls, name, getter) {
        Object.defineProperty(cls.prototype, name, {get: getter});
    }

    function extend(base, child, additionalSortColumns) {
        child.prototype = Object.create(base.prototype);
        child.constructor = child;
        child.extend = extend.bind(child, child);
    }

    Report.makeChildClass = function(cls, config) {
        config = config || {};
        cls.prototype = Object.create(Report.prototype);
        cls.prototype.$isList = !!config.isList;
        cls.prototype.$sorterConfig = config.sorter;
        cls.prototype.$itemClass = config.itemClass;
        cls.constructor = cls;
        cls.extend = extend.bind(cls, cls);
    }

    Report.prototype.update = function(params) {
        this.params = angular.copy(params);
        if (this.pager && this.loaded) { this.pager.page = 1; }
        return this.refresh();
    };

    Report.prototype.getExtraParams = function() {
        var extra = {}, params = this.$extraParameters || [], i;
        for (i = 0; i < params.length; i++) {
            extra[params[i]] = this[params[i]];
        }
        return extra;
    };

    Report.prototype.refresh = function() {
        var self =  this;
        $timeout.cancel(self.$timeoutCancel);

        self.$refreshPromise = self.$refreshPromise || $q.defer();

        self.$timeoutCancel = $timeout(function() {
            var params = angular.copy(self.params || {});
            angular.extend(params, self.getExtraParams());

            if (self.pager) {params.page = self.pager.page;}
            if (self.sorter) {
                params.sort = self.sorter.column;
                params.direction = self.sorter.direction;
            }

            self.loading = true;
            $http.get(self.url, {params: params})
                .then(self.setData.bind(self))
                .then(setLoaded(self))
                .then(function() {
                    if (self.$refreshPromise) {
                        self.$refreshPromise.resolve(self);
                        delete self.$refreshPromise;
                    }
                });
        });

        return self.$refreshPromise.promise;
    };

    Report.prototype.setData = function(httpResponse) {
        var data = httpResponse.data.item || httpResponse.data.items,
            itemClass = this.$itemClass, i;

        data = momentConvertFilter(data);

        if (angular.isArray(data) && itemClass) {
            data = data.map(function(item) {
                return new itemClass(item);
            })
        }

        function copyExtra(name) {
            if (httpResponse.data[name]) {
                if (this[name]) {
                    angular.copy(
                        momentConvertFilter(httpResponse.data[name]),
                        this[name]);
                } else {
                    this[name] = angular.copy(
                        momentConvertFilter(httpResponse.data[name]));
                }
            }
        }

        if (httpResponse.data.extra_names) {
            for (i = 0; i < httpResponse.data.extra_names.length; i++) {
                copyExtra.call(this, httpResponse.data.extra_names[i]);
            }
        }

        angular.copy(data, this.data);
        // copyExtra.call(this, 'counts');
        // copyExtra.call(this, 'meta');

        if (this.pager) {
            this.pager.setData(httpResponse.data.pager || {});
        }
    };


    Report.addExtraParameter = function(cls, name, change) {
        cls.prototype.$extraParameters = cls.prototype.$extraParameters || [];
        cls.prototype.$extraParameters.push(name);

        var attr = "_" + name;
        Object.defineProperty(cls.prototype, name, {
            get: function() { return this[attr]; },
            set: function(value) {
                this[attr] = value;
                if (this.pager) this.pager.page = 1;
                this.refresh();
                (change || angular.noop).call(this, name, value);
            },
        });
    };

    return Report;

});

function makePercentGetter(numeratorName, denominatorName) {
    return function() {
        var denom = (this.data && this.data[denominatorName]),
            num = (this.data && this.data[numeratorName]);
        return denom && ((num || 0) * 100) / denom;
    }
}
